<template>
  <ul class="frisbuy-rating-bar">
    <li
      v-for="rating in props.divisionByRating"
      :key="rating.label"
      class="frisbuy-rating-bar__rate"
    >
      <label class="frisbuy-rating-bar__rate-label"> {{ rating.label }} </label>
      <span class="frisbuy-rating-bar__rate-icon">
        <StarRounded width="12px" v-if="!props.isSoftStarIcon" />
        <StarSoftRounded width="12px" v-else />
      </span>
      <div class="frisbuy-rating-bar__rate-progress-bar">
        <span
          class="frisbuy-rate-progress-bar__progress"
          :style="{ width: `${(rating.count / generalRating) * 100}%` }"
        ></span>
      </div>
      <span class="frisbuy-rating-bar__rate-count"> {{ rating.count }} </span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.frisbuy-rating-bar {
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  list-style: none;

  gap: 10px 0;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #606266;

  &,
  .frisbuy-rating-bar__rate {
    margin: 0;
    padding: 0;
  }

  .frisbuy-rating-bar__rate {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    gap: 0 4px;

    .frisbuy-rating-bar__rate-label {
      color: var(--frisbuy-color-primary);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      width: 11px;
      min-width: 12px;
    }

    .frisbuy-rating-bar__rate-icon {
      display: flex;
      color: #212121;

      :deep(svg path) {
        fill: #212121;
      }
    }

    .frisbuy-rating-bar__rate-progress-bar {
      position: relative;

      width: 278px;
      height: 4px;
      border-radius: 4px;

      background-color: var(--frisbuy-color-primary-6);

      .frisbuy-rate-progress-bar__progress {
        display: block;

        width: 0;
        height: 100%;
        background-color: var(--frisbuy-color-primary-5);

        border-radius: inherit;
      }
    }

    .frisbuy-rating-bar__rate-count {
      min-width: 24px;
      text-align: right;
      color: var(--frisbuy-color-primary-5);
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
    }
  }
}
</style>

<script setup lang="ts">
// Icons
import StarRounded from "../../Icons/StarRounded.vue";
import StarSoftRounded from "../../Icons/StarSoftRounded.vue";
// Types
import { TRating } from "../../interfaces";

const props = defineProps<{
  divisionByRating: Array<TRating>;
  isSoftStarIcon?: boolean;
}>();

const generalRating: number = props.divisionByRating.reduce(
  (accumulator, currentValue) => {
    return accumulator + currentValue.count;
  },
  0
);
</script>
